// @ts-strict-ignore
export function AppBannerSkeleton({ visible }: { visible: boolean }) {
	return (
		<div className={`app-banner__skeleton ${visible ? 'app-banner__skeleton--visible' : 'app-banner__skeleton--hidden'}`}>
			<div className="app-banner__skeleton__container">
				<div className="app-banner__skeleton__icon-wrapper">
					<div className="app-banner__skeleton__close-icon">
						<div className="app-banner__skeleton__shimmer" />
					</div>
				</div>
				<div className="app-banner__skeleton__image">
					<div className="app-banner__skeleton__shimmer" />
				</div>
				<div className="app-banner__skeleton__content">
					<div className="app-banner__skeleton__title">
						<div className="app-banner__skeleton__shimmer" />
					</div>
					<div className="app-banner__skeleton__description">
						<div className="app-banner__skeleton__shimmer" />
					</div>
				</div>
				<div className="app-banner__skeleton__cta-wrapper">
					<div className="app-banner__skeleton__cta">
						<div className="app-banner__skeleton__shimmer" />
					</div>
				</div>
			</div>
		</div>
	);
};
